import { React, useState } from "react";

//components
import { Grid, Box } from "@mui/material";
import { Title } from "../../../../../components/Titles/FormTitles";
import AutoComplete from "../../../../../components/AutoComplete";
import TextField from "../../../../../components/TextFields/TextField";

//hooks
import useQueryAuth from "../../../../../hooks/useQueryAuth";

//translation
import { useTranslation } from "react-i18next";

import { v4 as uuidv4 } from "uuid";
import useAuth from "../../../../../hooks/useAuth";
import { GET_ALL_COMPANIES_DROPDOWN } from "../../../../../graphql/company";
import { useParams } from "react-router-dom";

const Main = ({ formData }) => {
	const { t } = useTranslation();
	const { tID } = useParams();

	const {
		values,
		formField,
		setFieldValue,
		wait,
		readOnly,
		fromTenant,
		createMode,
	} = formData;
	const { storeUserGuid, storeUserTenant } = useAuth();
	const { name, code, companyID } = formField;

	const { name: nameV, code: codeV, companyID: companyIdV } = values;

	const {
		data: companiesData,
		loading: companyLoading,
		tokenChange: companyWait,
	} = useQueryAuth(GET_ALL_COMPANIES_DROPDOWN, "GetAllCompanies", {
		skip: !createMode,
		variables: {
			model: {
				enableFilters: false,
				userID: storeUserGuid,
				tenantID: fromTenant ? tID : storeUserTenant,
			},
		},
	});

	const companies = companiesData?.GetAllCompanies?.compList?.companies || [];

	return (
		<Box>
			<Grid container spacing={3}>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					<Title style={{ padding: "10px 0" }}>
						{t("customerForm.customerInformation.title")}
					</Title>
				</Grid>

				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<TextField
						autoFocus
						fullWidth
						value={nameV}
						onChange={(e) => {
							setFieldValue(name.name, e.target.value);
						}}
						label={t(name.label)}
						name={name.name}
						formData={formData}
						required
						disabled={readOnly}
					/>
				</Grid>

				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<AutoComplete
						options={companies}
						getOptionLabel={(option) => (option ? option.name : "")}
						renderOption={(props, option) => (
							<li {...props} key={uuidv4()}>
								{option.name}
							</li>
						)}
						identifier={"companyGuid"}
						value={companyIdV}
						onChange={(e, value) => {
							setFieldValue(companyID.name, value);
						}}
						loading={companyLoading}
						required
						disabled={readOnly || !createMode}
						name={companyID.name}
						fullWidth
						label={t(companyID.label)}
						formData={formData}
					/>
				</Grid>

				<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
					<TextField
						fullWidth
						value={codeV}
						onChange={(e) => {
							setFieldValue(code.name, e.target.value);
						}}
						label={t(code.label)}
						name={code.name}
						formData={formData}
						required={true}
						disabled={readOnly || !createMode}
					/>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Main;
